<!-- OEC建议配置 -->
<template>
  <div class="recommended-config atb-flex atb-flex-column atb-full-height">
    <div class='atb-content-bg atb-flex atb-flex-column atb-full-height'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" v-on:keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <el-form-item label="被建议人">
            <!-- <el-input v-model="searchParam.ReWkNo" placeholder="输入工号或姓名查询" clearable></el-input> -->
            <selecter v-model="searchParam.ReWkNo" placeholder="输入工号或姓名查询"></selecter>
          </el-form-item>
          <el-form-item class="flex-form-item" label="建议人">
            <selecter v-model="searchParam.WkNo" placeholder="输入工号或姓名查询"></selecter>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
            <el-button type="add" @click="add">新建</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="export" @click="exportExcel">导出</el-button>
          </el-form-item>
          <!-- <el-form-item v-if="$auth(that, 'Import')"> -->
          <el-form-item>
            <el-upload ref="file" :http-request="uploadFile" :multiple="false" :show-file-list='false'>
              <el-button type="import">导入</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="downloadTemplate" @click="downloadTemplate">下载模板</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <vxe-table class='atb-table header-table edit-table' border='inner' height='100%' auto-resize resizable :seq-config="{seqMethod}"
          :data="tableData" ref="dataTable" @checkbox-change="handledSelectChange" @checkbox-all="selectAllEvent" @cell-click="expandRow">
          <!-- <vxe-table-column type='checkbox' width='40'></vxe-table-column> -->
          <vxe-table-column type="seq" title="NO." width='60'></vxe-table-column>
          <vxe-table-column field="reWkNo" title="被建议人" width='150'>
            <template #default="{ row }">{{ row.reWkName }}<span v-if="row.reWkNo">({{row.reWkNo}})</span></template>
          </vxe-table-column>
          <vxe-table-column field="reDepartment" title="被建议人部门" width="200"></vxe-table-column>
          <vxe-table-column field="wkNo" title="建议人" width="150">
            <template #default="{ row }">{{ row.wkName }}<span v-if="row.wkNo">({{row.wkNo}})</span></template>
          </vxe-table-column>
          <vxe-table-column field="department" title="建议人部门" width="200"></vxe-table-column>
          <vxe-table-column field="startMonth" title="开始月份" width="100">
            <template #default="{ row }">{{ row.startYear }}-{{row.startMonth}}</template>
          </vxe-table-column>
          <vxe-table-column field="endMonth" title="结束月份" width="100">
            <template #default="{ row }">{{ row.endYear }}-{{row.endMonth}}</template>
          </vxe-table-column>
          <vxe-table-column field="remarks" title="备注" min-width="200">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remarks }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" fixed="right" width='120' class-name='operation'>
            <template #default="scope">
              <el-tooltip class='item' effect='dark' content='编辑' placement="bottom">
                <i class='icon-editor' @click.stop='edit({ row: scope.row })'></i>
              </el-tooltip>
              <el-tooltip class='item' effect='dark' content='删除' placement="bottom">
                <i class='icon-close delete' @click.stop='deleteTip(scope.row)'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
        </vxe-table>

      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager background :current-page.sync="page.PageIndex" :page-size.sync="page.PageSize" :total="total"
          height="100%" @page-change="handlePageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']">
        </vxe-pager>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="content">
        <h2>确定要删除吗</h2>
        <p>此操作会删除对应的工作项</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="del">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
      </span>
    </el-dialog>
    <common-dialog ref="commonDialog" :title="dialogContent.title" width="500px" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :editData="editRow" @submitSuccess="getList(1)"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import tableMixin from '@/mixins/table.mixin'
export default {
  name: 'RecommendedConfig',
  mixins: [tableMixin],
  components: {
    Edit: () => import('./Edit'),
    selecter: () => import('@/component/global/customerSelect'),
  },
  data() {
    return {
      downloadUrl: process.env.VUE_APP_PUBLICPATH + "files/OEC建议配置导入模板.xlsx",
      that: this,
      showDelTip: false,
      row: {},

      searchParam: {},
      page: {
        PageIndex: 1,
        PageSize: 10,
      },
      total: 0,
      tableData: [],
      editRow: {},
    }
  },
  mounted() {
    this.getList(1);
  },
  methods: {
    // 格式化序列号
    seqMethod({ rowIndex }) {
      return rowIndex + (this.page.PageIndex - 1) * this.page.PageSize + 1;
    },
    getList(page) {
      if(page) {
        this.page.PageIndex = page;
      }
      const pageParam = { ...this.page, ...this.searchParam };
      this.$ajax.get(this.$api.recommendedConfig.list, pageParam).then((res) => {
        this.tableData = res.data.rows || [];
        this.tableData.forEach(item => {
          this.$set(item, 'expandRowFlag', false);
        });
        this.total = res.data.total;
      });
    },
    handlePageChange({ currentPage }) {
      this.getList(currentPage);
    },
    add() {
      this.isEdit = false;
      this.editRow = {};
      this.dialogContent = {
        title: '新建',
        componentName: 'Edit'
      }
      this.$refs.commonDialog.show()
    },
    edit({row}) {
      this.isEdit = true;
      this.editRow = typeof (row) == 'object' ? row || {} : {};
      this.dialogContent = {
        title: '编辑',
        componentName: 'Edit'
      }
      this.$refs.commonDialog.show()
    },

    exportExcel() {
      this.$ajax.get(this.$api.recommendedConfig.exportFile, { ...this.searchParam, ...this.page }, { ignore: true, responseType: 'blob' }).then((res) => {
        if (res.data.type == 'application/json') {
          var reader = new FileReader();
          reader.onload = () => {
            var content = reader.result;//内容就在这里
            let json = JSON.parse(content)
            this.$message.error(json.message)
          };
          reader.readAsText(res.data);
        } else {
          const filename = 'OEC建议配置'
          const filetype = 'xlsx'
          let data = res.data;
          let url = window.URL.createObjectURL(data)
          let a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          a.download = filename + '.' + filetype
          a.click()
          window.URL.revokeObjectURL(url)
        }
      }).catch(() => { })
    },
    downloadTemplate() {
      window.location.href = this.downloadUrl;
    },
    uploadFile({ file }) {
      const params = new FormData();
      params.append('excelfile', file);
      this.$ajax.post(this.$api.recommendedConfig.importFile, params, { headers: { 'Content-Type': 'multipart/form-data;' } }).then((res) => {
        if (res.code === 0) {
          this.$message.success('上传成功');
          this.getList(1);
        }
      });
    },
    deleteTip(row) {
      this.showDelTip = true;
      this.row = row;
    },
    del() {
      if (this.row) {
        this.$ajax.get(this.$api.recommendedConfig.del + '?id=' + this.row.id).then(() => {
          this.$message.success('删除成功');
          this.getList(1);
        }).finally(() => {
          this.showDelTip = false;
        });
      }
    },
    expandRow({row}) {
      row.expandRowFlag = !row.expandRowFlag;
      this.$refs.dataTable.updateData(this.tableData);
    },
  }
}
</script>
<style scoped lang='scss'>
.recommended-config {
  .link-ele {
    margin: 0 5px;
  }

  ::v-deep .vxe-table--render-default.size--medium .vxe-header--column:not(.col--ellipsis) {
    padding: 12px 0;
  }

  ::v-deep .vxe-table--render-default.vxe-editable.size--medium .vxe-body--column {
    height: 48px;
  }

  ::v-deep .vxe-table--render-default.size--medium .vxe-header--column.col--ellipsis {
    height: 48px;
  }

  .el-button--import {
    background-color: #def6e8;
    border-color: #def6e8;
    color: #0dcc82;
  }

  ::v-deep .el-button--downloadTemplate {
    width: 100px !important;
    background-color: #def6e8;
    border-color: #def6e8;
    color: #0dcc82;
  }
  ::v-deep .el-dialog__body {
    padding-top: 33px!important;
    text-align: center;
    h2 {
      font-size: 18px;
      color: #4a5150;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p {
      color: #687371;
    }
  }
}
</style>
